import React from 'react';

import { useBusinessToolSessionStore } from 'store/useBusinessToolStore';
import { getBusinessToolMode } from 'store/useBusinessToolStore/selectors';

import { checkIsPreviewMode } from 'pages/BusinessToolPage/utils';

import { Responsive } from 'components/_basic/Responsive';
import { OnePageTypeSwitch } from 'components/OnePage';

import { TNavigationRenderFn } from '../../../types';
import { ModeSwitch } from '../../ModeSwitch/ModeSwitch';

interface IOnePageShortNavigationProps {
  render: TNavigationRenderFn;
}

export const OnePageShortNavigation: React.FC<IOnePageShortNavigationProps> = ({ render }) => {
  const businessToolMode = useBusinessToolSessionStore(getBusinessToolMode);
  const isPreviewMode = checkIsPreviewMode(businessToolMode);

  return render({
    modeSwitch: <ModeSwitch />,
    typeSwitch: <Responsive aboveMobile>{!isPreviewMode && <OnePageTypeSwitch />}</Responsive>,
  });
};
